import { useState, type FormEvent } from 'react';
import { supabase } from '../lib/supabaseClient';
import { DemoModeLink } from '../components/DemoModeLink';

// Login do ADMIN — e-mail + senha (revisado em 2026-09-08, pedido
// explícito do proprietário: mais rápido que pedir um código por e-mail
// toda vez). A sessão do Supabase Auth já fica salva no navegador
// (persistSession, ver supabaseClient.ts) — uma vez logado, só pede login
// de novo se sair (Sair) ou limpar os dados do navegador.
//
// Erro de credencial incorreta é sempre a mesma mensagem genérica (nunca
// revela se foi o e-mail ou a senha) — o próprio Supabase já devolve um
// erro genérico ("Invalid login credentials") pra qualquer uma das duas
// situações.
//
// O influenciador NUNCA passa por esta tela — o acesso dele é só e-mail,
// sem conta nenhuma (ver InfluencerLoginPage.tsx).
export function AdminLoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleSubmit(event: FormEvent) {
    event.preventDefault();
    setLoading(true);
    setError(null);

    const { error: signInError } = await supabase.auth.signInWithPassword({
      email: email.trim().toLowerCase(),
      password,
    });

    setLoading(false);

    if (signInError) {
      setError('E-mail ou senha incorretos.');
    }
    // Sucesso: o AdminAuthProvider detecta a nova sessão automaticamente
    // (onAuthStateChange) e o App.tsx mostra o painel administrativo.
  }

  return (
    <div className="flex min-h-screen items-center justify-center px-4">
      <div className="card w-full max-w-sm p-6">
        <h1 className="font-display text-lg font-semibold tracking-tight">Painel Administrativo</h1>
        <p className="mt-1 text-sm text-[rgb(var(--text-muted))]">CA Render</p>

        <form className="mt-6 space-y-4" onSubmit={handleSubmit}>
          <div>
            <label className="label" htmlFor="email">
              E-mail
            </label>
            <input
              id="email"
              type="email"
              required
              autoFocus
              className="input"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              placeholder="voce@exemplo.com"
            />
          </div>
          <div>
            <label className="label" htmlFor="password">
              Senha
            </label>
            <input
              id="password"
              type="password"
              required
              className="input"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              placeholder="Sua senha"
            />
          </div>
          {error ? <p className="text-sm text-error">{error}</p> : null}
          <button type="submit" className="btn-primary w-full" disabled={loading}>
            {loading ? 'Entrando…' : 'Entrar'}
          </button>
        </form>
        <DemoModeLink to="/admin" />
      </div>
    </div>
  );
}
